import { usePocQuery } from 'core/custom-hooks/use-poc-query.hook';
import { QUERY_KEYS } from 'core/query-client/query-keys.constants';
import { CustomAlarmFormMode } from 'modules/settings/pods/settings-devices/settings-devices-configuration/settings-devices-custom-alarm-form/settings-devices-custom-alarm-form.model';
import { getCustomAlarmDefinitionById } from 'modules/settings/pods/settings-devices/settings-devices-configuration/settings-devices-custom-alarm-form/service/custom-alarm-form.service';

interface UseCustomAlarmDefinitionFetcherProps {
    mode: CustomAlarmFormMode;
    customAlarmId?: string;
}

export const useCustomAlarmDefinitionFetcher = ({ mode, customAlarmId }: UseCustomAlarmDefinitionFetcherProps) => {
    const enabled = mode === 'edit' && Boolean(customAlarmId);

    const { data: customAlarmDefinition, isFetching: isFormLoading } = usePocQuery({
        queryKey: QUERY_KEYS.CUSTOM_ALARM_DEFINITION_ID(customAlarmId!),
        queryFn: () => getCustomAlarmDefinitionById(customAlarmId!),
        enabled,
    });

    return {
        isFormLoading,
        customAlarmDefinition,
    };
};
